import { db } from "../firebase";
import {
  addDoc,
  collection,
  getDocs,
  serverTimestamp
} from "firebase/firestore";

const ANNOUNCEMENTS_COLLECTION = "announcements";

const formatAnnouncementDateTime = (date) => {
  if (!date || Number.isNaN(date.getTime?.())) return "";

  return date.toLocaleString("tr-TR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit"
  });
};

export const DEFAULT_ANNOUNCEMENTS = [];

export const getAnnouncements = async () => {
  const snapshot = await getDocs(collection(db, ANNOUNCEMENTS_COLLECTION));
  const firestoreAnnouncements = snapshot.docs
    .map((item) => {
      const data = item.data();
      const createdAtDate = data.createdAt?.toDate?.();

      const createdAtMillis = Number(data.createdAtMillis || 0) || createdAtDate?.getTime?.() || 0;

      return {
        id: item.id,
        ...data,
        createdAtMillis,
        createdAtText: createdAtDate
          ? formatAnnouncementDateTime(createdAtDate)
          : data.createdAtText || ""
      };
    })
    .filter((item) => item.isPublished !== false);

  const mergedAnnouncements = [
    ...firestoreAnnouncements,
    ...DEFAULT_ANNOUNCEMENTS
  ];

  const uniqueAnnouncements = new Map();
  mergedAnnouncements.forEach((item) => {
    if (!item?.id) return;
    uniqueAnnouncements.set(item.id, item);
  });

  return Array.from(uniqueAnnouncements.values())
    .sort((first, second) => Number(second.createdAtMillis || 0) - Number(first.createdAtMillis || 0));
};

export const createAnnouncement = async ({
  title,
  body,
  category = "Duyuru",
  priority = "normal",
  audience = "all",
  popupDisplayLimit = 1,
  createdBy = ""
}) => {
  const safePopupDisplayLimit = Math.min(
    Math.max(Number(popupDisplayLimit) || 1, 1),
    5
  );
  const now = new Date();

  return addDoc(collection(db, ANNOUNCEMENTS_COLLECTION), {
    title: String(title || "").trim(),
    body: String(body || "").trim(),
    category,
    priority,
    audience,
    popupDisplayLimit: safePopupDisplayLimit,
    isPublished: true,
    createdBy,
    createdAtMillis: now.getTime(),
    createdAtText: formatAnnouncementDateTime(now),
    createdAt: serverTimestamp()
  });
};
